import React from "react";
import UrlToLinks from "./UrlToLinks.jsx";
import CitationLinks from "./CitationLinks.jsx";

const CitationSegment = ({
  citation,
  summaryText,
  maxVisible,
  references,
  id,
  index
}) => {
  const citeStart = citation.startIndex || 0;
  const citeEnd = citation.endIndex || summaryText.length;
  
  if (citeStart >= maxVisible) {
    return null;
  }
  
  const visibleEnd = Math.min(citeEnd, maxVisible);
  const citeText = summaryText.substring(citeStart, visibleEnd);
  const isFullyVisible = visibleEnd === citeEnd;
  
  const hasSources = citation.sources && citation.sources.length > 0;
  const hasReferenceIndex = citation.referenceIndex !== undefined;
  const hasReferences = references && references.length > 0;
  
  let citationSources = [];
  if (hasSources) {
    citationSources = citation.sources
      .map(source => {
        const refId = source.referenceId !== undefined 
          ? (typeof source.referenceId === 'string' ? parseInt(source.referenceId, 10) : source.referenceId)
          : (source.referenceIndex !== undefined ? source.referenceIndex : null);
        return refId !== null ? { referenceIndex: refId } : null;
      })
      .filter(source => source !== null);
  } else if (hasReferenceIndex) {
    citationSources = [{ referenceIndex: citation.referenceIndex }];
  }
  
  const shouldShowCitation = isFullyVisible && citationSources.length > 0 && hasReferences;
  
  return (
    <span key={`${id}-citation-segment-${index}`}>
      <UrlToLinks text={citeText} keyPrefix={`${id}-citation-${index}`} />
      {shouldShowCitation && (
        <span className="ai-overview__citation">
          <CitationLinks
            sources={citationSources}
            references={references}
            id={id}
            citationIndex={index}
          />
        </span>
      )}
    </span>
  );
};

export default CitationSegment;

